// extracted by mini-css-extract-plugin
export default {"root":"CloudIcon_root__KxwQd"};